import { TOOL } from './Tools.js'

/**
 * ToolButtons
 *
 * Canonical mapping between painting tool button IDs and TOOL enum values.
 * Shared by Visualizer + PaintingUIBinder to keep tool IDs consistent.
 */

const TOOL_BUTTON_ID = Object.freeze({
    BRUSH: 'btnbrush',
    ERASER: 'btneraser',
    ROTATE: 'btnrotate',
    MAGIC: 'btnmagic',
    HAND: 'btnhand',
    DRAW_LINE: 'btndrawline',
    DRAW_POLY_PLUS: 'btndrawpolyplus',
    DRAW_POLY_MINUS: 'btndrawpolyminus',
})

const TOOL_BUTTON_SELECTOR = Object.freeze({
    BRUSH: `#${TOOL_BUTTON_ID.BRUSH}`,
    ERASER: `#${TOOL_BUTTON_ID.ERASER}`,
    ROTATE: `#${TOOL_BUTTON_ID.ROTATE}`,
    MAGIC: `#${TOOL_BUTTON_ID.MAGIC}`,
    HAND: `#${TOOL_BUTTON_ID.HAND}`,
    DRAW_LINE: `#${TOOL_BUTTON_ID.DRAW_LINE}`,
    DRAW_POLY_PLUS: `#${TOOL_BUTTON_ID.DRAW_POLY_PLUS}`,
    DRAW_POLY_MINUS: `#${TOOL_BUTTON_ID.DRAW_POLY_MINUS}`,
})

const TOOL_BY_BUTTON_ID = Object.freeze({
    [TOOL_BUTTON_ID.BRUSH]: TOOL.BRUSH,
    [TOOL_BUTTON_ID.ERASER]: TOOL.ERASER,
    [TOOL_BUTTON_ID.MAGIC]: TOOL.MAGIC,
    [TOOL_BUTTON_ID.HAND]: TOOL.HAND,
    [TOOL_BUTTON_ID.DRAW_LINE]: TOOL.DRAW_LINE,
    [TOOL_BUTTON_ID.DRAW_POLY_PLUS]: TOOL.DRAW_POLY_PLUS,
    [TOOL_BUTTON_ID.DRAW_POLY_MINUS]: TOOL.DRAW_POLY_MINUS,
})

const ACTIVE_PAINT_TOOL_BUTTON_SELECTOR = '.viz-dropcolors-tools .paint-btn.is-active, .viz-dropcolors-tools .paint-btn.btn-activated'

export { ACTIVE_PAINT_TOOL_BUTTON_SELECTOR, TOOL_BUTTON_ID, TOOL_BUTTON_SELECTOR, TOOL_BY_BUTTON_ID }
